import { FC } from 'react';

import { PageLoadingIndicator } from '@mopla/ui';

export const TrueLayerRedirectHandlerRoute: FC = () => {
	/**
	 * This is the place of the intermediate redirect from TrueLayer Authorization page back to Mopla index page.
	 * A user is not expected to see anything here, the `navigate` is expected to happen immediately
	 *
	 * @see README.md
	 * @see PaymentPostProcessor.tsx
	 * @see AppRouter.tsx (passenger)
	 * */
	return <PageLoadingIndicator />;
};
